import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-add-user-icon',
  templateUrl: './communication-add-user.component.html'
})
export class CommunicationAddUserComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
